import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false, moderatorOrAbove = false }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-blueprint">
        <div className="font-mono text-sm text-eas-blue eas-tick">[ AUTHENTICATING ]</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/quote-portal/login" replace />;
  const role = user.role;
  if (adminOnly && role !== "super_admin" && role !== "admin") {
    return <Navigate to="/quote-portal" replace />;
  }
  if (moderatorOrAbove && !["super_admin", "admin", "moderator"].includes(role)) {
    return <Navigate to="/quote-portal" replace />;
  }
  return children;
}
